import { useTranslation } from 'libs/i18n';
import {
  ClientType,
  FormBodyWrapper,
} from 'modules/onboarding/common/components';

import {
  CompanyConstituentDocsFormType,
  FormErrors,
  getSchema,
} from '../../forms/companyConstituentDocs';

import { FormContent, FormContentProps } from './FormContent';

interface Props extends FormContentProps {
  initialValues?: CompanyConstituentDocsFormType;
  onSubmit: (values: CompanyConstituentDocsFormType) => void;
  canGoBack?: boolean;
  onGoBack?: () => void;
  formError?: FormErrors;
  submitLoading?: boolean;
  submitDisabled?: boolean;
  clientType?: ClientType;
}

export const CompanyConstituentDocs = ({
  initialValues,
  canGoBack,
  onGoBack,
  submitLoading,
  formError,
  onSubmit,
  clientType,
  submitDisabled,
  ...formProps
}: Props) => {
  const { t } = useTranslation();
  const schema = getSchema(t, formProps.enabledDateOfLastChange);
  return (
    <FormBodyWrapper
      canGoBack={canGoBack}
      clientType={clientType}
      initialErrors={formError}
      initialValues={initialValues}
      submitDisabled={submitDisabled}
      submitLoading={submitLoading}
      subTitle={t('onboarding.companyConstituentDocs.subtitle')}
      title={t('onboarding.companyConstituentDocs.title')}
      validationSchema={schema}
      onGoBack={onGoBack}
      onSubmit={onSubmit}
    >
      <FormContent {...formProps} />
    </FormBodyWrapper>
  );
};
